import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/mui/Modal'
import Typography from 'components/mui/Typography'
import { Box, CircularProgress } from '@mui/material'

/**
 * LoadingModal - Modal component for displaying loading states
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} LoadingModal
 */
const LoadingModal = ({
  open,
  title = "Account Verification in Progress",
  description = "A small test deposit is being made to verify your account securely. Please wait a moment.",
  spinnerColor = "#42A5F5",
  spinnerSize = 40,
  sx = {}
}) => {
  // Component scope - Constants and static data
  const modalStyle = {
    width: '100%',
    bgcolor: '#13172A',
    borderRadius: '12px',
    p: 4,
    borderOpacity: 0.3
  }

  const titleStyle = {
    color: '#FFFFFF',
    fontSize: '20px',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: '16px',
    lineHeight: '1.2',
  }

  const descriptionStyle = {
    color: '#FFFFFF',
    fontSize: '14px',
    textAlign: 'center',
    marginBottom: '32px',
    lineHeight: '1.4',
  }

  const spinnerContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pb: 2
  }

  // Return/rendering
  return (
    <Modal
      open={open}
      sx={{
        // Set width to match content
        width: { xs: '90%', sm: 400, md: 400 },
        maxWidth: '90vw',
        // Ensure centering is maintained (Modal already has these, but being explicit)
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        padding: 0,
        ...sx
      }}
    >
      <Box sx={modalStyle}>

        {/* Loading Spinner */}
        <Box sx={spinnerContainerStyle}>
          <CircularProgress
            size={spinnerSize}
            sx={{
              color: spinnerColor,
            }}
          />
        </Box>
        {/* Title */}
        <Typography sx={titleStyle}>
          {title}
        </Typography>

        {/* Description */}
        <Typography sx={descriptionStyle}>
          {description}
        </Typography>


      </Box>
    </Modal>
  )
}

LoadingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  spinnerColor: PropTypes.string,
  spinnerSize: PropTypes.number
}

LoadingModal.defaultProps = {
  title: "Loading...",
  description: "Please wait while we process your request.",
  spinnerColor: "#42A5F5",
  spinnerSize: 40
}

export default LoadingModal
